import { CreateWorkStepsEnum } from '../enum/create-work-steps-enum';

export const createFormStepper = [
  CreateWorkStepsEnum.preStepWorkType,
  CreateWorkStepsEnum.generalBase,
  CreateWorkStepsEnum.generalSecond,
  CreateWorkStepsEnum.jobCoverPhoto,
  CreateWorkStepsEnum.workSkills,
  CreateWorkStepsEnum.workContact,
  CreateWorkStepsEnum.workShare,
];

export const formStepper = {
  [CreateWorkStepsEnum.preStepWorkType]: {
    stepId: CreateWorkStepsEnum.preStepWorkType,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 0,
  },
  [CreateWorkStepsEnum.generalBase]: {
    stepId: CreateWorkStepsEnum.generalBase,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 1,
  },
  [CreateWorkStepsEnum.generalSecond]: {
    stepId: CreateWorkStepsEnum.generalSecond,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 2,
  },
  [CreateWorkStepsEnum.jobCoverPhoto]: {
    stepId: CreateWorkStepsEnum.jobCoverPhoto,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 3,
  },
  [CreateWorkStepsEnum.workSkills]: {
    stepId: CreateWorkStepsEnum.workSkills,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 4,
  },
  [CreateWorkStepsEnum.workContact]: {
    stepId: CreateWorkStepsEnum.workContact,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 5,
  },
  [CreateWorkStepsEnum.workShare]: {
    stepId: CreateWorkStepsEnum.workShare,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 6,
  },
  [CreateWorkStepsEnum.congratulations]: {
    stepId: CreateWorkStepsEnum.congratulations,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 7,
  },
};
